import { RiExternalLinkLine } from '@remixicon/react';
import { TextField } from '@mui/material';
import { FormSectionTemplate } from '../../../components/AdminTemplates';
import { useLanguage } from '../../../contexts/language';
import { useCurrentUser } from '../../../contexts/currentUser';
import { Language } from '../../../types/language';

const ProfilePage = () => {
  const { t, language } = useLanguage();
  const { user: userDetails, userOperator } = useCurrentUser();

  return (
    <FormSectionTemplate
      title={t('content.my-profile')}
      onSubmit={() => null}
      goBackLinkText={''}
      goBackLinkUrl={'/'}
    >
      <label className="block mb-4">
        <header>{t('content.first-name')}</header>
        <TextField value={userDetails.firstName} disabled />
      </label>

      <label className="block mb-4">
        <header>{t('content.last-name')}</header>
        <TextField value={userDetails.lastName} disabled />
      </label>

      <label className="block mb-4">
        <header>{t('content.email')}</header>
        <TextField value={userDetails.email} disabled />
      </label>

      <label className="block mb-4">
        <header>{t('content.role')}</header>
        <TextField value={t(`role.${userDetails.role}`)} disabled />
      </label>

      {userOperator && (
        <label className="block mb-4">
          <header>{t('content.operator')}</header>
          <TextField value={userOperator.operatorName} disabled />
        </label>
      )}

      <a
        href={`https://${import.meta.env.VITE_AUTH_KNOWN_AUTHORITIES}/${import.meta.env.VITE_AUTH_DOMAIN}/oauth2/v2.0/authorize?p=B2C_1_PASSWORDRESET&client_id=${import.meta.env.VITE_AUTH_CLIENT_ID}&redirect_uri=${import.meta.env.VITE_AUTH_REDIRECT_URI}&scope=openid&response_type=id_token&ui_locales=${language === Language.EN ? 'en' : 'ga-IE'}`}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center text-blue-600 hover:underline mt-16"
      >
        {t('content.change-password')}
        <RiExternalLinkLine className="ml-1" />
      </a>
    </FormSectionTemplate>
  );
};

export default ProfilePage;
